import React from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { useTheme } from '@/contexts/ThemeContext';

interface AntdThemeProviderProps {
  children: React.ReactNode;
}

export const AntdThemeProvider: React.FC<AntdThemeProviderProps> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
          colorBgContainer: theme === 'dark' ? '#1f1f1f' : '#ffffff',
          colorBgElevated: theme === 'dark' ? '#262626' : '#ffffff',
          colorBgLayout: theme === 'dark' ? '#141414' : '#f5f5f5',
          colorText: theme === 'dark' ? '#ffffff' : '#000000',
          colorTextSecondary: theme === 'dark' ? '#8c8c8c' : '#666666',
          colorBorder: theme === 'dark' ? '#434343' : '#d9d9d9',
          colorBorderSecondary: theme === 'dark' ? '#303030' : '#f0f0f0',
        },
        components: {
          Layout: {
            bodyBg: theme === 'dark' ? '#141414' : '#ffffff',
            headerBg: theme === 'dark' ? '#1f1f1f' : '#ffffff',
            siderBg: theme === 'dark' ? '#1f1f1f' : '#fafafa',
          },
          Menu: {
            itemBg: 'transparent',
            itemSelectedBg: theme === 'dark' ? '#262626' : '#e6f7ff',
            itemSelectedColor: theme === 'dark' ? '#ffffff' : '#1890ff',
            itemColor: theme === 'dark' ? '#ffffff' : '#000000',
            itemHoverBg: theme === 'dark' ? '#262626' : '#f5f5f5',
            itemHoverColor: theme === 'dark' ? '#ffffff' : '#1890ff',
          },
          Button: {
            defaultBg: theme === 'dark' ? '#262626' : '#ffffff',
            defaultBorderColor: theme === 'dark' ? '#434343' : '#d9d9d9',
            defaultColor: theme === 'dark' ? '#ffffff' : '#000000',
            textHoverBg: theme === 'dark' ? '#262626' : '#f5f5f5',
          },
          Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
          },
          Card: {
            colorBgContainer: theme === 'dark' ? '#1f1f1f' : '#ffffff',
            colorBorderSecondary: theme === 'dark' ? '#434343' : '#f0f0f0',
          },
          Modal: {
            contentBg: theme === 'dark' ? '#1f1f1f' : '#ffffff',
            headerBg: theme === 'dark' ? '#1f1f1f' : '#ffffff',
          },
          Drawer: {
            colorBgElevated: theme === 'dark' ? '#1f1f1f' : '#ffffff',
          },
          Table: {
            colorBgContainer: theme === 'dark' ? '#1f1f1f' : '#ffffff',
            colorFillAlter: theme === 'dark' ? '#262626' : '#fafafa',
          },
          Dropdown: {
            colorBgElevated: theme === 'dark' ? '#1f1f1f' : '#ffffff',
            colorText: theme === 'dark' ? '#ffffff' : '#000000',
          },
          Tooltip: {
            colorBgSpotlight: theme === 'dark' ? '#434343' : '#ffffff',
            colorTextLightSolid: theme === 'dark' ? '#ffffff' : '#000000',
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
